import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, setupRequired, refresh } = useAuth();
  const location = useLocation();

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (setupRequired === true) {
    return <Navigate to="/setup" replace />;
  }

  if (user === null || setupRequired === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0b0b0d] text-zinc-400">
        <div className="flex items-center gap-2 text-sm" data-testid="loading-indicator">
          <LoaderCircle className="size-4 animate-spin" strokeWidth={1.7} />
          Chargement…
        </div>
      </div>
    );
  }

  if (user === undefined) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}
